export default "__VITE_ASSET__1a420119__"